var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenVector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 15,
    viewBox: "0 0 9 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.91275e-05 13.8554V1.14457C-0.00128691 0.918541 0.064317 0.697245 0.188466 0.508893C0.312616 0.32054 0.489685 0.173664 0.6971 0.0869902C0.904516 0.00031648 1.13288 -0.022228 1.35308 0.0222313C1.57327 0.0666905 1.77532 0.176139 1.93347 0.336623L8.24264 6.69775C8.45323 6.91096 8.57143 7.19937 8.57143 7.5C8.57143 7.80063 8.45323 8.08904 8.24264 8.30225L1.93347 14.6634C1.77532 14.8239 1.57327 14.9333 1.35308 14.9778C1.13288 15.0222 0.904516 14.9997 0.6971 14.913C0.489685 14.8263 0.312616 14.6795 0.188466 14.4911C0.064317 14.3028 -0.00128691 14.0815 1.91275e-05 13.8554Z",
    fill: "url(#paint0_linear_9_10440)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9_10440",
    x1: 8.57143,
    y1: 7.67333e-7,
    x2: -14.7252,
    y2: 14.6316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9DFC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85DDDE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenVector);
export default __webpack_public_path__ + "static/media/green-vector.467ef0a70af8491cfc4754e9f31cfbb6.svg";
export { ForwardRef as ReactComponent };